export default __webpack_public_path__ + "static/compareItemImg3-5178de1fbbcc08cd440bfa54214a71a3.png";